import React, { useState, useEffect, memo } from 'react';
import { useRouter } from 'next/router';
import { SignInLayout } from './sign-in-layout/index';
import { ChurchSearchContainer } from './church-search/index';
import { getAccountDataThunk, getUser } from '../../redux/slices/user';
import { useDispatch, useSelector } from 'react-redux';
import CustomAlert from '../alert';
import { clearRegisterData, clearErrors } from '../../redux/slices/user';
import { churchRemove, churchSelect } from '../../redux/slices/church';
import Loader from '../loader/index';
import useToastify from '../../utils/hooks/use-toastify';
import { churchSearchByDomain } from '../../services/church.service';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const SignInComponent = () => {
  const router = useRouter();
  const [authData, setAuthData] = useState({
    email: '',
    password: '',
  });
  const dispatch = useDispatch();
  const { userData } = useSelector((store) => store.user);
  const { churchInfo } = useSelector((state) => state.church);
  const [loader, setLoader] = useState(false);
  const { error } = useSelector((store) => store.user);

  useEffect(() => {
    dispatch(clearRegisterData());
    dispatch(clearErrors());
    const church = JSON.parse(localStorage.getItem('current_church'));
    dispatch(churchSelect(church));
  }, []);

  useEffect(() => {
    if (router.query.slug) {
      churchSearchByDomain(router.query.slug)
      .then((res) => {
        if (res.data.data.length > 0) {
          selectChurch({...res.data.data[0]});
        }
      })
      .catch(err => console.log(err));
    }
  }, [router.query.slug]);

  const selectChurch = (data) => {
    dispatch(churchSelect(data));
    localStorage.setItem('current_church', JSON.stringify(data));
    localStorage.setItem('newChurchId', data.id);
  };

  const handleChurchChange = () => {
    dispatch(churchRemove());
    localStorage.removeItem('current_church');
  };

  useEffect(() => {
    setLoader(false);
  }, [error]);

  const handleErrorData = useToastify();

  const handleInputChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    if (/ /g.test(value)) return;

    setAuthData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleKeyPress = (event) => {
    if (event.charCode === 13) onLogin();
  };

  const onLogin = () => {
    setLoader(true);
    if (!authData.email || !authData.password) {
      return;
    }
    if (!localStorage.getItem('newChurchId')) {
      localStorage.setItem('newChurchId', churchInfo.id);
    }
    try {
      dispatch(
        getAccountDataThunk({
          email: authData.email,
          password: authData.password,
          church_id: churchInfo.id,
        })
      );
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <Loader isLoading={loader} />
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {churchInfo !== null ? (
        <SignInLayout
          authData={authData}
          handleInputChange={handleInputChange}
          onLogin={onLogin}
          handleErrorData={handleErrorData}
          handleKeyPress={handleKeyPress}
          handleChurchChange={handleChurchChange}
          churchInfo={churchInfo}
        />
      ) : (
        <ChurchSearchContainer selectChurch={selectChurch} />
      )}
      {alert.open && (
        <CustomAlert
          open={alert.open}
          alertType={alert.alertType}
          text={alert.text}
        />
      )}
    </>
  );
};
